'use strict';
module.exports = require('./Fieldset.vue');